module.exports = __webpack_public_path__ + "static/media/6.22_preview.fc0579cd.png";